// src/category.ts
var STATIQUE = "STATIQUE";
var BAR = "BAR";
var MANUTENTION = "MANUTENTION";
var FUN = "FUN";
var RELOU = "RELOU";
var COLLAGE = "COLLAGE";
var taskCategories = [
  STATIQUE,
  BAR,
  MANUTENTION,
  FUN,
  RELOU,
  COLLAGE
];

// src/action.ts
var CREATED = "CREATED";
var COMMENTED = "COMMENTED";
var READY_TO_REVIEW = "READY_TO_REVIEW";
var APPROVED = "APPROVED";
var REJECTED = "REJECTED";
var RESET_REVIEW = "RESET_REVIEW";
var ASSIGNMENT_STARTED = "ASSIGNMENT_STARTED";
var FORCED_UPDATE = "FORCED_UPDATE";

// src/review.ts
var REVIEWING = "REVIEWING";
var NOT_ASKING_TO_REVIEW = "NOT_ASKING_TO_REVIEW";
var WILL_NOT_REVIEW = "WILL_NOT_REVIEW";
var A_RELIRE = "\xC0 relire";
var REJETEE = "Rejet\xE9e";
var APPROUVEE = "Approuv\xE9e";
var PAS_DE_RELECTURE = "Pas de relecture";
var NE_VA_PAS_RELIRE = "Ne va pas relire";
var reviewLabels = /* @__PURE__ */ new Map([
  [REVIEWING, A_RELIRE],
  [APPROVED, APPROUVEE],
  [REJECTED, REJETEE],
  [NOT_ASKING_TO_REVIEW, PAS_DE_RELECTURE],
  [WILL_NOT_REVIEW, NE_VA_PAS_RELIRE]
]);

// src/status.ts
var DRAFT = "DRAFT";
var IN_REVIEW = "IN_REVIEW";
var VALIDATED = "VALIDATED";
var REFUSED = "REFUSED";
var READY_TO_ASSIGN = "READY_TO_ASSIGN";
var BROUILLON = "Brouillon";
var RELECTURE_EN_COURS = "Relecture en cours";
var VALIDEE = "Valid\xE9e";
var REFUSEE = "Refus\xE9e";
var PRETE_POUR_AFFECTATION = "Pr\xEAte pour affectation";
var statusLabels = /* @__PURE__ */ new Map([
  [DRAFT, BROUILLON],
  [IN_REVIEW, RELECTURE_EN_COURS],
  [REFUSED, REFUSEE],
  [VALIDATED, VALIDEE],
  [READY_TO_ASSIGN, PRETE_POUR_AFFECTATION]
]);
export {
  APPROUVEE,
  APPROVED,
  ASSIGNMENT_STARTED,
  A_RELIRE,
  BAR,
  BROUILLON,
  COLLAGE,
  COMMENTED,
  CREATED,
  DRAFT,
  FORCED_UPDATE,
  FUN,
  IN_REVIEW,
  MANUTENTION,
  NE_VA_PAS_RELIRE,
  NOT_ASKING_TO_REVIEW,
  PAS_DE_RELECTURE,
  PRETE_POUR_AFFECTATION,
  READY_TO_ASSIGN,
  READY_TO_REVIEW,
  REFUSED,
  REFUSEE,
  REJECTED,
  REJETEE,
  RELECTURE_EN_COURS,
  RELOU,
  RESET_REVIEW,
  REVIEWING,
  STATIQUE,
  VALIDATED,
  VALIDEE,
  WILL_NOT_REVIEW,
  reviewLabels,
  statusLabels,
  taskCategories
};
